import { type EndpointResponse, type Result } from "~/features/bulkAddToCart/api/sendTextForValidation";

import * as ApiHelper from "~/common/utils/ApiHelper";
import { transformPreviewItem } from "~/features/bulkAddToCart/utils/transformers";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const apiUrl = resolveApiUrl("/bulkupload/upload/file");
export function sendData(file: File): Promise<Result> {
  // file

  const data = new FormData();
  data.append("file", file);

  const params: RequestInit = {
    body: data,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  };

  return fetch(apiUrl, params)
    .then((res) => res.json())
    .then((json: EndpointResponse) => {
      if (Array.isArray(json)) {
        return {
          products: json.map(transformPreviewItem),
        };
      } else {
        return {
          error: json,
          products: [],
        };
      }
    });
}
